module.exports = __webpack_public_path__ + "static/media/garmin.b7fae03f.png";